"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcAspectRatio = void 0;
var calcAspectRatio = function (aspectRatio) {
    var split = aspectRatio.split("/");
    return !split[1]
        ? parseInt(split[0])
        : parseInt(split[0]) / parseInt(split[1]);
};
exports.calcAspectRatio = calcAspectRatio;
